// Upcoming webinars, planned in advance.
//
// To schedule a webinar, add an entry to WEBINARS below. Order does not
// matter — the site always shows the *next* webinar that hasn't expired.
//
// Fields per webinar:
//   date      ISO 8601 start date/time (use ...Z for UTC).
//   dachLink  registration/join link for DACH countries (DE, AT, CH).
//
// A webinar is considered expired one hour after its start date, after
// which the next upcoming webinar (if any) takes over automatically.

// Registration link for all non-DACH countries. Static across webinars.
const DEFAULT_LINK =
  "https://airtable.com/app6wLZFQV5c8KrGS/pagsePWT9InjB8HZt/form";

export const WEBINARS = [
  {
    date: "2026-07-23T14:30:00Z",
    dachLink:
      "https://events.teams.microsoft.com/event/3719087c-af95-4987-a23b-79b02c26658e@76088e79-c22e-402c-a189-20c9f10808d4",
  },
  {
    date: "2026-08-13T14:30:00Z",
    dachLink:
      "https://events.teams.microsoft.com/event/9669a89a-1cdf-4882-945c-2b62a7143020@76088e79-c22e-402c-a189-20c9f10808d4",
  },
  {
    date: "2026-09-22T07:30:00Z",
    dachLink:
      "https://events.teams.microsoft.com/event/c8962bb0-347c-4bd8-8f03-e6a04a657020@76088e79-c22e-402c-a189-20c9f10808d4",
  },
  {
    date: "2026-10-22T06:30:00Z",
    dachLink:
      "https://events.teams.microsoft.com/event/f7acbf2f-569d-42b7-9f13-3a1b61f76727@76088e79-c22e-402c-a189-20c9f10808d4",
  },
  {
    date: "2026-11-19T07:30:00Z",
    dachLink:
      "https://events.teams.microsoft.com/event/e47bbd2b-75cf-43bf-9622-78370236dd0b@76088e79-c22e-402c-a189-20c9f10808d4",
  },
];

// A webinar stays visible until one hour after it starts.
const EXPIRY_MS = 60 * 60 * 1000;

const DACH = ["DE", "AT", "CH"];

// The next webinar that hasn't expired yet, or null if none is scheduled.
export const nextWebinar = (now = new Date()) =>
  WEBINARS.filter(
    (webinar) => new Date(webinar.date).getTime() + EXPIRY_MS > now.getTime(),
  ).sort((a, b) => new Date(a.date) - new Date(b.date))[0] || null;

// The registration link for a webinar, chosen by country code.
export const webinarLink = (webinar, countryCode) =>
  !webinar
    ? null
    : countryCode && DACH.includes(countryCode)
    ? webinar.dachLink
    : DEFAULT_LINK;
